export default __webpack_public_path__ + "static/media/OMODARA SUIT -  Product and Digital Marketing Practice Lead.0c365588.png";